import { render, staticRenderFns } from "./jobseeker-notifications.vue?vue&type=template&id=3c7bfa1a"
import script from "./jobseeker-notifications.vue?vue&type=script&lang=js"
export * from "./jobseeker-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports